import { Controller } from "@hotwired/stimulus"

/** Glass marketing nav: add elevation when page is scrolled */
export default class extends Controller {
  static classes = ["scrolled"]

  connect() {
    this.onScroll = this.onScroll.bind(this)
    window.addEventListener("scroll", this.onScroll, { passive: true })
    this.onScroll()
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
  }

  onScroll() {
    const y = window.scrollY
    this.element.classList.toggle(this.scrolledClass, y > 10)
  }
}
